import { Ref, computed } from '@vue/composition-api';

export function useFilter<T>(
	items: Ref<T[]>,
	filter: (t: T) => boolean,
): Ref<T[]> {
	return computed(() => items.value.filter(filter));
}
